import React, { useState, useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import Header from "@/components/Header";
import "../common/css/common.scss";
import Connect from "@/components/Connect";
import NavigationModal from "@/components/NavigationModal";
import { api_haiboPhone, mtClick, mt4Page } from "@/api/api";
import { getQueryString } from "@/utils/utility";
import { usePhoneNumberState } from "@/utils/PhoneNumberContext";
import { TAB_LIST } from "@/utils/Contant";

const userLayout = () => {
  const { pathname } = useLocation();
  const [showNavigation, setShowNavigation] = useState(false);
  const { phoneNumber, setPhoneNumber } = usePhoneNumberState();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowNavigation(true);
    }, 10000);

    getPhone();

    checkUrlParameters();

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const curItem = TAB_LIST.filter((tabItem) =>
      pathname.includes(tabItem.key)
    )?.[0];

    initLog(curItem?.logId, curItem?.label);
  }, [pathname]);

  // PV埋点
  const initLog = async (logId, pageName) => {
    await mt4Page(
      {
        currentPageName: logId,
        currentPageCn: pageName,
        ref_page_name: pageName,
        ref_page_url: pathname,
      },
      1
    );
  };

  // 检查url是否带有参数
  const checkUrlParameters = () => {
    // 定义默认来源
    const DEFAULT_SOURCE = "hiboos";

    // 获取来源参数
    const sourceParam = getQueryString("from");

    // 使用参数值或默认值
    const fromSource = sourceParam || DEFAULT_SOURCE;

    try {
      // 设置来源相关的数据
      setDjMs(`isFrom_${fromSource}`, `来源_${fromSource}`);
    } catch (error) {
      console.error("设置来源数据时出错:", error);
    }
  };

  // 来源埋点
  const setDjMs = async (clickId, clickName) => {
    await mtClick("", "", clickId, clickName, "", "", {}, {});
  };

  const getPhone = () => {
    api_haiboPhone({})
      .then((res) => {
        if (res && res.result) {
          setPhoneNumber(res.result.contractPhone);
        }
      })
      .catch((e) => {
        console.log(e);
        setPhoneNumber("");
      });
  };
  return (
    <div className="min_width">
      {showNavigation && pathname == "/home" ? (
        <NavigationModal
          isShow={showNavigation}
          onClose={() => {
            setShowNavigation(false);
          }}
        />
      ) : null}
      <Connect />
      <Header />
      {/* 使用 <Outlet /> 渲染子路由 */}
      <Outlet />
    </div>
  );
};
export default userLayout;
